<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col>
                    <h2 v-text="this.editing ? this.$route.params.id : 'Nueva'"></h2>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col md="3">
                    <v-text-field v-model="currentAditivo.cod_aditivo" :rules="[(v) => !!v || 'Código es necesario']"
                        label="Código" required>
                    </v-text-field>
                </v-col>
                <v-col>
                    <v-text-field v-model="currentAditivo.descripcion" :rules="[(v) => !!v || 'Descripción es necesario']"
                        label="Descripción" required>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-autocomplete v-model="currentAditivo.id_color" :items="colores" :item-text="getColorName"
                        item-value="id_color" label="Color" prepend-icon="mdi-palette" return-object chips>

                        <template v-slot:selection="data">
                            <v-chip v-bind="data.attrs" :input-value="data.item.id_color" close @click="data.select"
                                @click:close="removeColor(data.item)">
                                {{ getColorName(data.item) }}
                            </v-chip>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col>
                    <v-autocomplete v-model="model_utilidad" :items="utilidades" label="Utilidad" prepend-icon="mdi-tools"
                        item-text="nombre" item-value="id_utilidad" multiple return-object chips>

                        <template v-slot:selection="data">
                            <v-chip v-bind="data.attrs" :input-value="data.item.id_utilidad" close @click="data.select"
                                @click:close="removeUtilidad(data.item)">
                                {{ data.item.nombre }}
                            </v-chip>
                        </template>

                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col md="2">
                    <v-text-field v-model="currentAditivo.temp_servicio" label="Temperatura Servicio"
                        prepend-icon="mdi-thermometer" type="number" clearable suffix="ºC" />
                </v-col>
                <v-col md="2">
                    <v-text-field v-model="currentAditivo.densidad" label="Densidad" prepend-icon="mdi-dots-hexagon"
                        type="number" clearable />
                </v-col>
                <v-col md="2">
                    <v-text-field v-model="currentAditivo.decimales" label="Decimales" type="number" clearable />
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="currentAditivo.fda" label="FDA" />
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="currentAditivo.green_strength" label="Green Strength" />
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="currentAditivo.prioritario" label="Prioritario" />
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col md="2">
                    <v-checkbox v-model="currentAditivo.aceite" label="Aceite" />
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="currentAditivo.cables" label="Cables" />
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="currentAditivo.desmoldeo" label="Desmoldeo" />
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="currentAditivo.esponja" label="Esponja" />
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="currentAditivo.fuego" label="Fuego" />
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="currentAditivo.grasa" label="Grasa" />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <template>
                        <v-data-table v-if="equivalenciasAditivo" :headers="tabla_equivalencias"
                            :items="equivalenciasAditivo" class="elevation-1" hide-default-footer>

                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Equivalencias</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                    <v-dialog v-model="dialogEquivalencia" max-width="600px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                                Añadir
                                            </v-btn>
                                        </template>

                                        <v-card>
                                            <v-card-title>
                                                <span class="text-h5">{{ formEquivalenciaTitle }}</span>
                                            </v-card-title>

                                            <v-card-text>
                                                <v-container>
                                                    <v-form ref="formEquivalencia">
                                                        <v-row>
                                                            <v-col>
                                                                <v-autocomplete
                                                                    v-model="editedEquivalenciaItem.cod_aditivo_destino_id"
                                                                    :items="aditivos" :item-text="getEquivalenciaText"
                                                                    item-value="cod_aditivo" label="Codigo" return-object>
                                                                </v-autocomplete>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col>
                                                                <v-text-field dense v-model="editedEquivalenciaDosis.origen"
                                                                    :label="currentAditivo.cod_aditivo" outlined
                                                                    type="number">
                                                                </v-text-field>
                                                            </v-col>
                                                            <v-col>
                                                                <v-text-field dense
                                                                    v-model="editedEquivalenciaDosis.destino"
                                                                    :label="editedEquivalenciaItem.cod_aditivo_destino_id.cod_aditivo ? editedEquivalenciaItem.cod_aditivo_destino_id.cod_aditivo : editedEquivalenciaItem.cod_aditivo_destino_id"
                                                                    outlined type="number">
                                                                </v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                        <div class="mt-3 red--text">{{ errorEquivalencias }}</div>
                                                    </v-form>

                                                </v-container>
                                            </v-card-text>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="blue darken-1" text @click="closeEquivalencia">
                                                    Cancelar
                                                </v-btn>
                                                <v-btn color="blue darken-1" text @click="saveEquivalencia">
                                                    Guardar
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>

                                    <v-dialog v-model="dialogEquivalenciaDelete" max-width="500px">
                                        <v-card>
                                            <v-card-title class="text-h5">¿Estás seguro de borrar la Equivalencia?
                                            </v-card-title>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="blue darken-1" text @click="closeEquivalenciaDelete">
                                                    Cancelar
                                                </v-btn>
                                                <v-btn color="blue darken-1" text @click="deleteEquivalenciaItemConfirm">
                                                    Borrar
                                                </v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-toolbar>
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <v-icon small class="mr-2" @click="editEquivalenciasItem(item)">
                                    mdi-pencil
                                </v-icon>
                                <v-icon small @click="deleteEquivalenciasItem(item)">
                                    mdi-delete
                                </v-icon>
                            </template>

                        </v-data-table>
                    </template>
                </v-col>
                <v-col md="6" v-if="this.editing">
                    <template>
                        <v-data-table v-if="currentAditivo.proveedor_aditivo" :headers="tabla_proveedores"
                            :items="currentAditivo.proveedor_aditivo" class="elevation-1" hide-default-footer>

                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Proveedores</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                        </v-data-table>
                    </template>
                </v-col>
            </v-row>

            <v-row align="center">
                <v-col align="center">
                    <v-btn v-if="this.editing" color="error" class="mr-2" @click="deleteAditivo">
                        Borrar
                    </v-btn>

                    <v-btn v-if="this.editing" color="success" @click="updateAditivo">
                        Actualizar
                    </v-btn>

                    <v-btn v-if="!this.editing" color="success" @click="saveAditivo">
                        Crear
                    </v-btn>
                </v-col>
            </v-row>

            <v-row v-if="this.editing">
                <v-col>
                    <template>
                        <v-data-table v-if="currentAditivo.formula_aditivo" :headers="tabla_formulas"
                            :items="currentAditivo.formula_aditivo" class="elevation-1">

                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Fórmulas con {{ currentAditivo.cod_aditivo }}</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                            <template v-slot:item.cod_formula.cod_formula="{ item }">
                                <router-link :to="'/formulas/' + item.cod_formula.cod_formula">{{
                                    item.cod_formula.cod_formula
                                }}</router-link>
                            </template>

                            <template v-slot:item.cod_formula.fda="{ item }">
                                <v-simple-checkbox v-model="item.cod_formula.fda" disabled></v-simple-checkbox>
                            </template>

                        </v-data-table>
                    </template>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import { mapMutations } from "vuex";
import ColoresDataService from "@/services/ColoresDataService";
import AditivosDataService from "@/services/AditivosDataService";
import UtilidadesDataService from "@/services/UtilidadesDataService";

export default {
    name: "AditivoId",
    props: ['id'],
    data() {
        return {
            editing: false,
            currentAditivo: {
                aceite: false,
                cables: false,
                cod_aditivo: "",
                decimales: 0,
                densidad: 0,
                descripcion: "",
                desmoldeo: false,
                equivalencia_aditivo_origen: [],
                equivalencia_aditivo_destino: [],
                esponja: false,
                fda: false,
                formula_aditivo: [],
                fuego: false,
                grasa: false,
                green_strength: false,
                id_color: null,
                prioritario: false,
                proveedor_aditivo: [],
                temp_servicio: 0,
                utilidad_aditivo: [],
            },
            isLoading: false,
            colores: [],
            searchColores: null,
            utilidades: [],
            model_utilidad: [],
            tabla_proveedores: [
                { text: "Ref.", value: "cod_proveedor.referencia" },
                { text: "Nombre", value: "cod_proveedor.nombre" },
                { text: "Precio", value: "precio" },
            ],
            tabla_equivalencias: [
                { text: "Origen", value: "cod_aditivo_origen_id" },
                { text: "Dosis", value: "dosis" },
                { text: "Destino", value: "cod_aditivo_destino_id" },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            tabla_formulas: [
                { text: "Codigo", value: "cod_formula.cod_formula" },
                { text: "Descripción", value: "cod_formula.descripcion" },
                { text: "FDA", value: "cod_formula.fda" },
                { text: "PPC", value: "ppc" },
            ],
            equivalenciasAditivo: [],
            aditivos: [],
            errorEquivalencias: "",
            dialogEquivalencia: false,
            dialogEquivalenciaDelete: false,
            editedEquivalenciaIndex: -1,
            editedEquivalenciaDosis: {
                origen: 0,
                destino: 0,
            },
            editedEquivalenciaItem: {
                "dosis": "0:0",
                "cod_aditivo_origen_id": "",
                "cod_aditivo_destino_id": "",
            },
            defaultEquivalenciaItem: {
                "dosis": "0:0",
                "cod_aditivo_origen_id": "",
                "cod_aditivo_destino_id": "",
            },
        };
    },
    methods: {
        ...mapMutations("snackbar", ["setSnack"]),
        getEquivalenciaText(item) {
            return item.cod_aditivo + " (" + item.descripcion + ")"
        },
        removeColor(item) {
            this.currentAditivo.id_color = null;
        },
        removeUtilidad(item) {
            for (let i = 0; i < this.model_utilidad.length; i++) {
                const element = this.model_utilidad[i];
                if (element.id_utilidad === item.id_utilidad) {
                    this.model_utilidad.splice(i, 1);
                }
            }
        },
        getAditivo(id) {
            AditivosDataService.get(id)
                .then((response) => {
                    this.currentAditivo = response.data;

                    if (this.currentAditivo.utilidad_aditivo.length > 0) {
                        for (const element of this.currentAditivo.utilidad_aditivo) {
                            this.model_utilidad.push({ "id_utilidad": element.id_utilidad.id_utilidad, "nombre": element.id_utilidad.nombre })
                        }
                    }
                })
                .catch((e) => {
                    console.log(e);
                });

            AditivosDataService.getEquivalencias(id)
                .then((response) => {
                    this.equivalenciasAditivo = response.data;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        saveAditivo() {
            AditivosDataService.create(this.currentAditivo)
                .then((response) => {
                    AditivosDataService.updateEquivalencias(this.currentAditivo.cod_aditivo, this.equivalenciasAditivo)
                        .then((response) => {
                            AditivosDataService.updateUtilidades(this.currentAditivo.cod_aditivo, this.model_utilidad)
                                .then((response) => {
                                    this.setSnack({ message: "Creado correctamente", color: "success" });
                                    this.$router.push({ name: "AditivosList" });
                                })
                                .catch((e) => {
                                    if (e.response.data.detail) {
                                        this.setSnack({ message: e.response.data.detail, color: "error" });
                                    } else {
                                        this.setSnack({ message: e.message, color: "error" });
                                    }
                                    console.log(e);
                                });
                        })
                        .catch((e) => {
                            if (e.response.data.detail) {
                                this.setSnack({ message: e.response.data.detail, color: "error" });
                            } else {
                                this.setSnack({ message: e.message, color: "error" });
                            }
                            console.log(e);
                        });
                })
                .catch((e) => {
                    if (e.response.data.detail) {
                        this.setSnack({ message: e.response.data.detail, color: "error" });
                    } else {
                        this.setSnack({ message: e.message, color: "error" });
                    }
                    console.log(e);
                });

        },
        updateAditivo() {
            AditivosDataService.update(this.currentAditivo.cod_aditivo, this.currentAditivo)
                .then((response) => {
                    AditivosDataService.updateEquivalencias(this.currentAditivo.cod_aditivo, this.equivalenciasAditivo)
                        .then((response) => {
                            AditivosDataService.updateUtilidades(this.currentAditivo.cod_aditivo, this.model_utilidad)
                                .then((response) => {
                                    this.setSnack({ message: "Actualizado correctamente", color: "success" });
                                    this.$router.push({ name: "AditivosList" });
                                })
                                .catch((e) => {
                                    if (e.response.data.detail) {
                                        this.setSnack({ message: e.response.data.detail, color: "error" });
                                    } else {
                                        this.setSnack({ message: e.message, color: "error" });
                                    }
                                    console.log(e);
                                });
                        })
                        .catch((e) => {
                            if (e.response.data.detail) {
                                this.setSnack({ message: e.response.data.detail, color: "error" });
                            } else {
                                this.setSnack({ message: e.message, color: "error" });
                            }
                            console.log(e);
                        });
                })
                .catch((e) => {
                    if (e.response.data.detail) {
                        this.setSnack({ message: e.response.data.detail, color: "error" });
                    } else {
                        this.setSnack({ message: e.message, color: "error" });
                    }
                    console.log(e);
                });
        },
        deleteAditivo() {
            AditivosDataService.delete(this.currentAditivo.cod_aditivo)
                .then((response) => {
                    this.$router.push({ name: "AditivosList" });
                })
                .catch((e) => {
                    if (e.response.data.detail) {
                        this.setSnack({ message: e.response.data.detail, color: "error" });
                    } else {
                        this.setSnack({ message: e.message, color: "error" });
                    }
                    console.log(e);
                });
        },
        getColorName(item) {
            let str_color = item.nombre;
            if (item.ral != "") {
                str_color += " (" + item.ral + ")";
            }
            if (item.referencia != "") {
                str_color += " [" + item.referencia + "]";
            }
            return str_color
        },
        editEquivalenciasItem(item) {
            this.editedEquivalenciaIndex = this.equivalenciasAditivo.indexOf(item)
            this.editedEquivalenciaItem = Object.assign({}, item)
            this.editedEquivalenciaDosis.origen = this.editedEquivalenciaItem.dosis.split(':')[0]
            this.editedEquivalenciaDosis.destino = this.editedEquivalenciaItem.dosis.split(':')[1]
            this.dialogEquivalencia = true
        },

        deleteEquivalenciasItem(item) {
            this.editedEquivalenciaIndex = this.equivalenciasAditivo.indexOf(item)
            this.editedEquivalenciaItem = Object.assign({}, item)
            this.editedEquivalenciaDosis.origen = this.editedEquivalenciaItem.dosis.split(':')[0]
            this.editedEquivalenciaDosis.destino = this.editedEquivalenciaItem.dosis.split(':')[1]
            this.dialogEquivalenciaDelete = true
        },

        deleteEquivalenciaItemConfirm() {
            this.equivalenciasAditivo.splice(this.editedEquivalenciaIndex, 1)
            this.closeEquivalenciaDelete()
        },
        closeEquivalencia() {
            this.dialogEquivalencia = false
            this.$nextTick(() => {
                this.editedEquivalenciaItem = Object.assign({}, this.defaultEquivalenciaItem)
                this.editedEquivalenciaDosis.origen = 0
                this.editedEquivalenciaDosis.destino = 0
                this.editedEquivalenciaIndex = -1
            })
        },
        closeEquivalenciaDelete() {
            this.dialogEquivalenciaDelete = false
            this.$nextTick(() => {
                this.editedEquivalenciaItem = Object.assign({}, this.defaultEquivalenciaItem)
                this.editedEquivalenciaDosis.origen = 0
                this.editedEquivalenciaDosis.destino = 0
                this.editedEquivalenciaIndex = -1
            })
        },
        saveEquivalencia() {
            if (this.$refs.formEquivalencia.validate()) {
                if (this.editedEquivalenciaIndex < 0) {
                    this.editedEquivalenciaIndex = this.equivalenciasAditivo.length
                }
                if (this.editedEquivalenciaItem.cod_aditivo_destino_id === '') {
                    this.errorEquivalencias = "Seleccione una Aditivo"
                    return
                }
                if (this.editedEquivalenciaDosis.origen <= 0 || this.editedEquivalenciaDosis.destino <= 0) {
                    this.errorEquivalencias = "Las equivalencias deben ser números positivos"
                    return
                }
                if (this.editedEquivalenciaItem.cod_aditivo_destino_id.cod_aditivo) {
                    this.editedEquivalenciaItem.cod_aditivo_destino_id = this.editedEquivalenciaItem.cod_aditivo_destino_id.cod_aditivo
                }
                this.editedEquivalenciaItem.dosis = this.editedEquivalenciaDosis.origen + ":" + this.editedEquivalenciaDosis.destino
                if (this.editedEquivalenciaIndex < this.equivalenciasAditivo.length) {
                    Object.assign(this.equivalenciasAditivo[this.editedEquivalenciaIndex], this.editedEquivalenciaItem)
                } else {
                    this.equivalenciasAditivo.push(this.editedEquivalenciaItem)
                }
                this.closeEquivalencia()
            } else {
                this.setSnack({ message: "Complete los campos necesarios.", color: "error" });
            }
        },
    },
    mounted() {
        this.editing = false;
        if (this.$route.params.id) {
            this.getAditivo(this.$route.params.id);
            this.editing = true;
        }

        this.isLoading = true
        ColoresDataService.getSimple()
            .then((response) => {
                this.colores = response.data
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false))

        UtilidadesDataService.getSimple()
            .then((response) => {
                this.utilidades = response.data
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false))

        AditivosDataService.getSimple()
            .then((response) => {
                this.aditivos = response.data
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false))
    },
    computed: {
        formEquivalenciaTitle() {
            if (this.editedEquivalenciaIndex === -1) {
                return 'Nuevo'
            } else {
                return 'Editar'
            }
        }
    },
    watch: {
        dialogEquivalencia(val) {
            this.editedEquivalenciaItem.cod_aditivo_origen_id = this.currentAditivo.cod_aditivo
            val || this.closeEquivalencia()
        },
        dialogEquivalenciaDelete(val) {
            val || this.closeEquivalenciaDelete()
        },
        '$route.params.id'(newId, oldId) {
            this.editing = false;
            this.currentAditivo = {
                cod_aditivo: "",
                descripcion: "",
                color: null,
                densidad: 0,
                fda: false,
                decimales: 0,
                prioritario: false,
            };
        }
    }
};
</script>